// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeFrontSideActions.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { compose, withHandlers, withProps } from 'recompose';
import { curry } from 'lodash/fp';
import GridPreviewPopup from '../Izenda.GridPreviewPopup';
import MapGridPreviewStore from 'logic/Izenda.MapGridPreviewStore';

/**
 * Change point option handler
 * @param {Object} props
 * @param {Object} key
 * @param {Object} value
 */
function onChangePointOption(props: any, key: any, value: any): void {
  const { reportPart } = props;
  const reportPartContent = reportPart.reportPartContent || {};

  reportPartContent.setActivePointOption(key, value);
}

/**
 * Show grid preview popup
 * @param {Object} props
 * @param {Object} e
 */
function showGridPreviewPopup(props: any, e: any) {
  props.openPopup(GridPreviewPopup, {
    reportPart: props.reportPart,
    gridPreviewStore: new MapGridPreviewStore(),
    shownRecords: props.shownRecords
  });
}

export default compose(
  withProps(() => ({
    hideGridPopup: false
  })),
  withHandlers({
    onChangePointOption: curry(onChangePointOption),
    showGridPreviewPopup: curry(showGridPreviewPopup)
  })
);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartMap/Izenda.MapToolbarActions.js